export default "__VITE_PUBLIC_ASSET__97b21d43__"